import React from 'react';
import CookieHelper from '../../Helpers/cookieHelper';
import { PLANNING_GRAPH_COLORS } from '../../Constants/PlanningGraphColors';

// Bravo design-system planning graph legend (handoff: legend-handoff). Closed
// trigger button <-> fixed bottom-right card panel. Open/closed is remembered via
// the existing ColorInfoBoxPl cookie; default closed when unset.
function GraphLegend() {
  const cookie = CookieHelper.getCookie(CookieHelper.CookieNameEnum.ColorInfoBoxPl);
  const [open, setOpen] = React.useState(cookie === 'true');

  const toggle = (next) => {
    setOpen(next);
    CookieHelper.setCookie(CookieHelper.CookieNameEnum.ColorInfoBoxPl, next);
  };

  return (
    <div className='bravo-ds'>
      <div className='gl-wrap'>
        {open ? (
          <div className='gl-panel'>
            <div className='gl-head'>
              <span className='eq-mark'>
                <span></span>
                <span></span>
              </span>
              <span className='gl-title'>Graph Legend</span>
              <button
                className='gl-close'
                onClick={() => toggle(false)}
                aria-label='Close legend'
              >
                <svg
                  width='13'
                  height='13'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.7'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='M6 6l12 12M18 6L6 18' />
                </svg>
              </button>
            </div>
            <div className='gl-grid'>
              {PLANNING_GRAPH_COLORS.map(({ label, color }) => (
                <div
                  key={label}
                  className='gl-item'
                >
                  <span
                    className='gl-swatch'
                    style={{ background: color }}
                  ></span>
                  <span className='gl-label'>{label}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <button
            className='gl-trigger'
            onClick={() => toggle(true)}
          >
            <svg
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='1.7'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <path d='M12 3a9 9 0 1 0 9 9h-9z' />
              <path d='M12 3v9' />
            </svg>
            Graph Legend
          </button>
        )}
      </div>
    </div>
  );
}

export default GraphLegend;
